import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { api } from "../api/api";

const KEY = "schulmilch_text";
const DEFAULT_TEXT = "Hier steht bald mehr zum Thema Schulmilch.";

export default function Schulmilch() {
  const { user } = useAuth();
  const isAdmin = !!user?.isAdmin;
  const [text, setText] = useState(DEFAULT_TEXT);
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState("");
  const [msg, setMsg] = useState(null);

  useEffect(() => {
    api.einstellungen.get(KEY).then(r => { if (r) setText(r); }).catch(() => {});
  }, []);

  async function save() {
    try {
      await api.einstellungen.update(KEY, draft);
      setText(draft);
      setEditing(false);
      setMsg("✓ Gespeichert!");
      setTimeout(() => setMsg(null), 3000);
    } catch { setMsg("Fehler beim Speichern."); }
  }

  return (
    <div className="container" style={{ maxWidth: 800 }}>
      <h2 className="section-title" style={{ marginTop: "1rem" }}>🏫 Schulmilch</h2>
      <div className="card" style={{ marginTop: "1.5rem", lineHeight: "1.9" }}>
        {editing ? (
          <>
            <textarea rows={6} value={draft} onChange={e => setDraft(e.target.value)} style={TA} />
            <div style={{ marginTop: "0.75rem", display: "flex", gap: "0.5rem" }}>
              <button className="btn btn-primary" onClick={save}>Speichern</button>
              <button className="btn btn-secondary" onClick={() => setEditing(false)}>Abbrechen</button>
            </div>
          </>
        ) : (
          <>
            <p style={{ color: "#555", whiteSpace: "pre-wrap" }}>{text}</p>
            {isAdmin && (
              <button className="btn btn-secondary" style={{ marginTop: "0.75rem" }}
                onClick={() => { setDraft(text); setEditing(true); setMsg(null); }}>
                ✏️ Text bearbeiten
              </button>
            )}
          </>
        )}
        {msg && <p style={{ marginTop: "0.5rem", color: msg.startsWith("✓") ? "green" : "red" }}>{msg}</p>}
      </div>
    </div>
  );
}

const TA = { width: "100%", padding: "0.5rem", fontSize: "1rem", borderRadius: 6, border: "1px solid #ccc", resize: "vertical", fontFamily: "inherit" };
